import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestSignIn } from '../api/Reports'
import { errorAlert, sweetalertLogout } from '../helpers/SweetAlert';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {

  // states 
  // loaders 
  const [datalogin, setDataLogin] = useState(null);
  const [loading, setLoading] = useState(false);

  /**
   * funcion para almacenar la data del login en el localstorage
   */
  const _isAuth = () => {
    let dataLocal = JSON.parse(localStorage.getItem('dataLogin'));
    // navigate('upload-csv');
    if (dataLocal) {
      setDataLogin(dataLocal);
    }
  };

  useEffect(()=>{
    _isAuth()
  },[])

  /**
   * 
   * @param {object} data 
   * @returns null
   * 
   * funcion para 
   */
  const signIn = async (data) => {
    try {
      setLoading(true);
      const res = await requestSignIn(data);
      if (!res?.access_token) {
        setLoading(false);
        return;
      }
      const dataLogin = {
        token: res?.access_token,
        service: res?.service
      };
      localStorage.setItem('dataLogin', JSON.stringify(dataLogin));
      setLoading(false);
      setDataLogin(dataLogin);
      window.location.pathname = "/home";
    } catch (e) {
      errorAlert(
        '',
        e.message ||
          '¡Disculpe ha ocurrido un error inesperado, por favor intente mas tarde!.',
      );
      setLoading(false);
    }
  };

  // const signIn = () => {
  //   const dataLogin = {
  //     email:'email',
  //     token:'qwert',
  //     name: 'name'
  //   };
  //   setLoading(true)
  //   setTimeout(() => {
  //     localStorage.setItem("dataLogin", JSON.stringify(dataLogin));
  //     setLoading(false)
  //     setDataLogin(dataLogin)
  //     window.location.pathname = "/upload-csv";
  //   }, 1000);
  // }

  /**
   * funcion para limpiar el localstorage y cerrar la sesion de usuario
   */
  const logout = () => {
    localStorage.clear();
    setDataLogin(null);
    window.location.pathname = "/login"
  };

  /**
   * funcion que abre el modal para confirmar cierre de sesion 
   */
  const requestLogout = () => {
    sweetalertLogout('Quieres cerrar sesion?', '', 'warning', logout);
  };


  return (
    <AuthContext.Provider
      value={{
        datalogin,
        setDataLogin,
        loading,
        setLoading,
        signIn,
        requestLogout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export default AuthContext;
